import { ApiModel } from '@composable-api/api.model'

interface Attributes {
    [StaticPageModel.ATTR_CONTENT]: string
    [StaticPageModel.ATTR_CREATED_AT]: string
    [StaticPageModel.ATTR_HAS_AUTOMATIC_SLUG]: boolean
    [StaticPageModel.ATTR_ID]: number
    [StaticPageModel.ATTR_IS_ACTIVE]: boolean
    [StaticPageModel.ATTR_META_DESCRIPTION]: string | null
    [StaticPageModel.ATTR_META_FOLLOW]: boolean
    [StaticPageModel.ATTR_META_H1_TITLE]: string | null
    [StaticPageModel.ATTR_META_INDEX]: boolean
    [StaticPageModel.ATTR_META_TITLE]: string | null
    [StaticPageModel.ATTR_NAME]: string
    [StaticPageModel.ATTR_OG_DESCRIPTION]: string | null
    [StaticPageModel.ATTR_OG_IMAGE_ID]: number | null
    [StaticPageModel.ATTR_OG_TITLE]: string | null
    [StaticPageModel.ATTR_PAGE_NAME]: string | null
    [StaticPageModel.ATTR_PARENT_ID]: number | null
    [StaticPageModel.ATTR_POSITION]: number
    [StaticPageModel.ATTR_SHOW_ON_SITEMAP]: boolean
    [StaticPageModel.ATTR_SLUG]: string
    [StaticPageModel.ATTR_VIEW]: string
}

export class StaticPageModel extends ApiModel<Attributes> {
    static key = 'StaticPageModel'

    static readonly ATTR_CONTENT = 'content'
    static readonly ATTR_CREATED_AT = 'created_at'
    static readonly ATTR_HAS_AUTOMATIC_SLUG = 'has_automatic_slug'
    static readonly ATTR_ID = 'id'
    static readonly ATTR_IS_ACTIVE = 'is_active'
    static readonly ATTR_META_DESCRIPTION = 'meta_description'
    static readonly ATTR_META_FOLLOW = 'meta_follow'
    static readonly ATTR_META_H1_TITLE = 'meta_h1_title'
    static readonly ATTR_META_INDEX = 'meta_index'
    static readonly ATTR_META_TITLE = 'meta_title'
    static readonly ATTR_NAME = 'name'
    static readonly ATTR_OG_DESCRIPTION = 'og_description'
    static readonly ATTR_OG_IMAGE_ID = 'og_image_id'
    static readonly ATTR_OG_TITLE = 'og_title'
    static readonly ATTR_PAGE_NAME = 'page_name'
    static readonly ATTR_PARENT_ID = 'parent_id'
    static readonly ATTR_POSITION = 'position'
    static readonly ATTR_SHOW_ON_SITEMAP = 'show_on_sitemap'
    static readonly ATTR_SLUG = 'slug'
    static readonly ATTR_VIEW = 'view'

    get content() {
        return this._getAttribute(StaticPageModel.ATTR_CONTENT)
    }
    get createdAt() {
        return this._getAttribute(StaticPageModel.ATTR_CREATED_AT)
    }
    get hasAutomaticSlug() {
        return this._getAttribute(StaticPageModel.ATTR_HAS_AUTOMATIC_SLUG)
    }
    get id() {
        return this._getAttribute(StaticPageModel.ATTR_ID)
    }
    get isActive() {
        return this._getAttribute(StaticPageModel.ATTR_IS_ACTIVE)
    }
    get metaDescription() {
        return this._getAttribute(StaticPageModel.ATTR_META_DESCRIPTION)
    }
    get metaFollow() {
        return this._getAttribute(StaticPageModel.ATTR_META_FOLLOW)
    }
    get metaH1Title() {
        return this._getAttribute(StaticPageModel.ATTR_META_H1_TITLE)
    }
    get metaIndex() {
        return this._getAttribute(StaticPageModel.ATTR_META_INDEX)
    }
    get metaTitle() {
        return this._getAttribute(StaticPageModel.ATTR_META_TITLE)
    }
    get name() {
        return this._getAttribute(StaticPageModel.ATTR_NAME)
    }
    get ogDescription() {
        return this._getAttribute(StaticPageModel.ATTR_OG_DESCRIPTION)
    }
    get ogImageId() {
        return this._getAttribute(StaticPageModel.ATTR_OG_IMAGE_ID)
    }
    get ogTitle() {
        return this._getAttribute(StaticPageModel.ATTR_OG_TITLE)
    }
    get pageName() {
        return this._getAttribute(StaticPageModel.ATTR_PAGE_NAME)
    }
    get parentId() {
        return this._getAttribute(StaticPageModel.ATTR_PARENT_ID)
    }
    get position() {
        return this._getAttribute(StaticPageModel.ATTR_POSITION)
    }
    get showOnSitemap() {
        return this._getAttribute(StaticPageModel.ATTR_SHOW_ON_SITEMAP)
    }
    get slug() {
        return this._getAttribute(StaticPageModel.ATTR_SLUG)
    }
    get view() {
        return this._getAttribute(StaticPageModel.ATTR_VIEW)
    }
}
